import React, { useState } from 'react';
import './index.css';

const StudentDetailsView = () => {
  const [selectedOption, setSelectedOption] = useState('');
  const [enteredValue, setEnteredValue] = useState('');
  const [userDetails, setUserDetails] = useState([]);
  const [view, setViewDetails] = useState("INITIAL");
  const [selectedUser, setSelectedUser] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [editForm, setEditForm] = useState({});
  const api = process.env.REACT_APP_API;

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
    setEnteredValue('');
    setUserDetails([]);
    setViewDetails("INITIAL");
    setSelectedUser(null);
  };

  const handleValueChange = (event) => {
    setEnteredValue(event.target.value);
  };

  const fetchUserDetails = async () => {
    const token = localStorage.getItem("jwt_token");
    if (!token) return alert("You are not logged in.");
    if (!enteredValue.trim()) return alert("Please enter a valid value.");

    try {
      const response = await fetch(`${api}/student-details?${selectedOption}=${enteredValue}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        mode: 'cors',
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error("Server error response:", errorText);
        setViewDetails("FAILED");
        return;
      }

      const data = await response.json();
      if (data.length > 0) {
        setUserDetails(data);
        setViewDetails("SUCCESS");
      } else {
        setViewDetails("FAILED");
      }
    } catch (error) {
      console.error('Error fetching user details:', error.message);
      alert("Failed to fetch user details. Please login again.");
    }
  };

  const deleteEnquiry = async (id) => {
    const token = localStorage.getItem("jwt_token");
    if (!token) return alert("You are not logged in.");

    try {
      const response = await fetch(`${api}/delete-enquiry/${id}`, {
        method: "DELETE",
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        mode: 'cors',
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error("Delete error:", errorText);
        return alert("Failed to Delete: Unauthorized or Token Expired");
      }

      alert("Deleted Successfully");
      fetchUserDetails();
    } catch (e) {
      console.error("Error:", e.message);
      alert("Error deleting enquiry.");
    }
  };

  const handleEditClick = (user) => {
    setSelectedUser(user);
    setEditForm({ ...user });
    setEditMode(true);
  };

  const handleEditFormChange = (e) => {
    const { name, value } = e.target;
    setEditForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('jwt_token');
    if (!token) return alert('You are not logged in.');
    try {
      const response = await fetch(`${api}/enquiries/${editForm._id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(editForm),
      });
      if (!response.ok) {
        const errorText = await response.text();
        alert('Failed to update: ' + errorText);
        return;
      }
      alert('Updated successfully');
      setEditMode(false);
      setSelectedUser(null);
      fetchUserDetails();
    } catch (err) {
      alert('Error updating enquiry.');
    }
  };

  return (
    <div className="user-details-container">
      <div className="select-container">
        <select className="select-option" value={selectedOption} onChange={handleOptionChange}>
          <option value="">Select an option</option>
          <option value="mobile">Phone Number</option>
          <option value="aadhar">Aadhar Number</option>
          <option value="name">Name</option>
        </select>
      </div>

      <div className="input-container">
        <input
          type="text"
          className="input-field"
          value={enteredValue}
          onChange={handleValueChange}
          placeholder={`Enter ${selectedOption}`}
          disabled={!selectedOption}
        />
      </div>

      <div className="button-container">
        <button
          className="fetch-button"
          onClick={fetchUserDetails}
          disabled={!enteredValue}
        >
          Fetch User Details
        </button>
      </div>

      {view === "SUCCESS" && (
        <div className="table-container">
          <table className="user-details-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Course</th>
                <th>Mobile</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {userDetails.map((item, index) => (
                <tr key={index}>
                  <td>{item.name}</td>
                  <td>{item.coursePreferred}</td>
                  <td>{item.mobile}</td>
                  <td>
                    <button onClick={() => setSelectedUser(item)}>View</button>
                    <button onClick={() => handleEditClick(item)} style={{marginLeft: '5px', background: '#ffc107', color: '#222'}}>Edit</button>
                    <br />
                    <button onClick={() => deleteEnquiry(item._id)}>Delete</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

   {selectedUser && !editMode && (
  <div className="modal-overlay" onClick={() => setSelectedUser(null)}>
    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
      <span className="modal-close" onClick={() => setSelectedUser(null)}>&times;</span>
      <h2>Student Details</h2>

      <table className="modal-details-table">
        <tbody>
          {[
            { label: "Name", key: "name" },
            { label: "Mobile", key: "mobile" },
            { label: "Email", key: "email" },
            { label: "Aadhar", key: "aadhar" },
            { label: "Date of Birth", key: "dob" },
            { label: "Place", key: "place" },
            { label: "Address", key: "address" },
            { label: "Background", key: "background" },
            { label: "College/School", key: "collegeSchool" },
            { label: "Course Preferred", key: "coursePreferred" },
            { label: "Time Preferred", key: "timePreferred" },
            { label: "Source", key: "source" },
            { label: "Course Fee", key: "courseFee" },
            { label: "Counselor Name", key: "counselorName" },
            { label: "Parent Name", key: "parentName" },
            { label: "Parent Number", key: "parentMobile" },
            { label: "Remarks", key: "remarks" }
          ].map(({ label, key }) => (
            <tr key={key}>
              <td className="detail-label">{label}</td>
              <td className="detail-value">{selectedUser[key] || "-"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
)}

{selectedUser && editMode && (
  <div className="modal-overlay" onClick={() => { setEditMode(false); setSelectedUser(null); }}>
    <div className="modal-content" onClick={e => e.stopPropagation()}>
      <span className="modal-close" onClick={() => { setEditMode(false); setSelectedUser(null); }}>&times;</span>
      <h2>Edit Student Details</h2>
      <form onSubmit={handleEditSubmit} className="modal-details-table">
        {[
          { label: "Name", key: "name", type: "text" },
          { label: "Mobile", key: "mobile", type: "text" },
          { label: "Email", key: "email", type: "email" },
          { label: "Aadhar", key: "aadhar", type: "text" },
          { label: "Date of Birth", key: "dob", type: "date" },
          { label: "Place", key: "place", type: "text" },
          { label: "Address", key: "address", type: "text" },
          { label: "Background", key: "background", type: "text" },
          { label: "College/School", key: "collegeSchool", type: "text" },
          { label: "Course Preferred", key: "coursePreferred", type: "text" },
          { label: "Time Preferred", key: "timePreferred", type: "text" },
          { label: "Source", key: "source", type: "text" },
          { label: "Course Fee", key: "courseFee", type: "text" },
          { label: "Counselor Name", key: "counselorName", type: "text" },
          { label: "Parent Name", key: "parentName", type: "text" },
          { label: "Parent Number", key: "parentMobile", type: "text" },
          { label: "Remarks", key: "remarks", type: "text" }
        ].map(({ label, key, type }) => (
          <div key={key} style={{ marginBottom: '10px' }}>
            <label style={{ fontWeight: 600 }}>{label}:</label>
            <input
              type={type}
              name={key}
              value={editForm[key] || ''}
              onChange={handleEditFormChange}
              style={{ width: '100%', padding: '6px', borderRadius: '4px', border: '1px solid #ccc' }}
            />
          </div>
        ))}
        <button type="submit" style={{ marginTop: '10px', padding: '8px 20px', background: '#198754', color: 'white', border: 'none', borderRadius: '6px' }}>Save</button>
      </form>
    </div>
  </div>
)}
    </div>
  );
};

export default StudentDetailsView;
